import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { LangContext, LANG_KEY } from "@/i18n/LangContext";
import { STRINGS } from "@/i18n/strings";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import MarqueeRibbon from "@/components/site/MarqueeRibbon";
import Services from "@/components/site/Services";
import Manifesto from "@/components/site/Manifesto";
import About from "@/components/site/About";
import ContactSection from "@/components/site/ContactSection";
import Footer from "@/components/site/Footer";
import Privacy from "@/components/site/Privacy";

function Home({ lang }) {
  const navigate = useNavigate();

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  useEffect(() => {
    if (lang === "en" && localStorage.getItem(LANG_KEY) === "fi" && !window.location.hash) {
      navigate("/fi", { replace: true });
    }
  }, [lang, navigate]);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <LangContext.Provider value={lang}>
      <div className="min-h-screen bg-paper text-ink font-sans antialiased">
        <a href="#main" data-testid="skip-link" className="skip-link">
          {STRINGS[lang].skip}
        </a>
        <div className="noise-overlay" aria-hidden="true" />
        <Nav />
        <main id="main">
          <Hero />
          <MarqueeRibbon />
          <Services />
          <Manifesto />
          <About />
          <ContactSection />
        </main>
        <Footer />
        <Toaster position="top-center" />
      </div>
    </LangContext.Provider>
  );
}

function PrivacyPage({ lang }) {
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <LangContext.Provider value={lang}>
      <Privacy />
      <Toaster position="top-center" />
    </LangContext.Provider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home lang="en" />} />
        <Route path="/fi" element={<Home lang="fi" />} />
        <Route path="/privacy" element={<PrivacyPage lang="en" />} />
        <Route path="/fi/privacy" element={<PrivacyPage lang="fi" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
